// extracted by mini-css-extract-plugin
module.exports = {"banner":"_dNjPzG3","mobileButton":"_wBd5V9b"};